import { useClerk } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";

// Sign-out icon button rendered in the play Header next to the
// restart and audio-toggle controls. Only mounted when Clerk is
// configured (see Header.tsx hasClerk() gate).
export default function SignOutButton() {
  const { signOut } = useClerk();
  const navigate = useNavigate();

  const onClick = async () => {
    await signOut();
    navigate("/", { replace: true });
  };

  return (
    <button
      id="signout-btn"
      title="Sign out"
      aria-label="Sign out"
      onClick={onClick}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    </button>
  );
}
